import { useLocation, matchPath } from 'react-router-dom';
import Seo from './Seo';

// Titles and descriptions for the static public routes that appear in
// sitemap.xml. These pages had no <head> handling of their own, so they served
// index.html's homepage canonical and homepage title verbatim — which told
// Google they were all duplicates of "/" and made them impossible to index
// separately.
//
// Kept as one table rather than a <Seo> in each page because these routes carry
// fixed copy: one place to read, one place to edit, and no chance of a new
// public route quietly shipping with the homepage's metadata again.
//
// Routes whose title depends on data (SportPage, SquadDetailsPage) render their
// own <Seo> instead and are deliberately absent here, so the two never fight
// over the same tags.
// SEPARATORS, ONE CONVENTION: an em dash separates a page name from its
// descriptor, and " | Kynaix Sports" is the brand suffix. Titles were previously
// mixed between the two, and the brand half is the first thing Google truncates
// past ~60 characters — so where a title cannot fit the suffix it drops it
// entirely rather than being cut mid-word. Google appends the site name to
// results for a known domain either way.
const ROUTE_SEO = [
    {
        path: '/',
        title: 'Kynaix Sports — Run Tournaments, Build Squads & Play Live',
        description: 'Kynaix Sports is the all-in-one sports community platform. Create tournaments, build squads, track live scores, find players near you, and buy or sell sports gear — free.',
        ogTitle: 'Kynaix Sports — Your Game. Your Squad. Your Glory.',
        ogDescription: 'The all-in-one sports platform where athletes compete, connect, and conquer. Tournaments, live scoring, squads, and your entire sports life — in one place. Free.',
    },
    {
        path: '/marketplace',
        title: 'Buy & Sell Used Sports Gear Near You | Kynaix Sports',
        description: 'Buy and sell sports equipment near you. Racquets, bats, shoes and kit from players in your area, listed free on Kynaix Sports.',
    },
    {
        path: '/help',
        title: 'Help Centre — Tournaments, Squads & Scoring | Kynaix Sports',
        description: 'How to run tournaments, build squads, record live scores, and manage a sports academy on Kynaix Sports. Step-by-step guides for every feature.',
    },
    {
        path: '/contact',
        title: 'Contact Kynaix Sports',
        description: 'Get in touch with the Kynaix Sports team for support, partnership or press enquiries.',
    },
    {
        path: '/terms',
        title: 'Terms of Service | Kynaix Sports',
        description: 'The terms governing use of Kynaix Sports, including accounts, payments, tournaments and academy services.',
    },
    {
        path: '/privacy',
        title: 'Privacy Policy | Kynaix Sports',
        description: 'How Kynaix Sports collects, uses and protects your personal information.',
    },
    {
        path: '/cookies',
        title: 'Cookie Policy | Kynaix Sports',
        description: 'Which cookies Kynaix Sports sets, what each one is for, and how to change your preferences at any time.',
    },
];

export default function RouteSeo() {
    const { pathname } = useLocation();
    const match = ROUTE_SEO.find((r) => matchPath({ path: r.path, end: true }, pathname));
    if (!match) return null;
    return <Seo {...match} />;
}
